import styled from "styled-components";

export const LoginTemplate = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  background: ${(props) => props.theme.colors.white};
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const LoginBox = styled.div`
  width: calc(100vw - 50px);
  max-width: 300px;
`;
